import { BookingTabMenuEnum } from 'app/models';

export class BookingTabMenuModel {
    public static BookingRideTabMenuList: Array<any> = [
        { id: BookingTabMenuEnum.None, label: 'All' },
        { id: BookingTabMenuEnum.Bookings, label: 'Bookings' },
        { id: BookingTabMenuEnum.ScanAndRide, label: 'Scan & Ride' },
        { id: BookingTabMenuEnum.Scheduled, label: 'Scheduled' },
    ];

    public static BookingSendTabMenuList: Array<any> = [
        { id: BookingTabMenuEnum.None, label: 'All' },
        { id: BookingTabMenuEnum.Twenty, label: '20kg' },
        { id: BookingTabMenuEnum.OneHundred, label: '100kg' },
        { id: BookingTabMenuEnum.FiveHundred, label: '500kg' }
	];

	public static BookingTaxiTabMenuList: Array<any> = [
		{ id: BookingTabMenuEnum.None, label: 'All' },
		{ id: BookingTabMenuEnum.Bookings, label: 'Bookings' },
		{ id: BookingTabMenuEnum.Hailed, label: 'Hailed' },
		{ id: BookingTabMenuEnum.ScanAndRide, label: 'Scan & Ride' },
		{ id: BookingTabMenuEnum.Scheduled, label: 'Scheduled' }
	];
}
